module.exports = __webpack_public_path__ + "img/dailyplan_empty_state.29e4815.png";